import { Button, makeStyles, useTheme } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as UnauthorizedIllustration } from '../../../../assets/illustrations/globaleris-error-unauthorized.svg';
import { styles } from './unauthorizedError.styles';

export interface UnauthorizedErrorProps {
  email?: string;
  onRefresh?: () => void;
  onReportError?: () => void;
  onLogout?: () => void;
}

export const UnauthorizedError: React.FC<UnauthorizedErrorProps> = props => {
  const [t] = useTranslation(['httpErrors']);
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  return (
    <div className={classes.errorContainer}>
      <div className={classes.errorCode}>
        <UnauthorizedIllustration
          className={classes.errorImage}
          aria-label={t('httpErrors:unauthorized.title')}
        />
      </div>
      <div className={classes.errorDescription}>
        <h1>{t('httpErrors:unauthorized.title')}</h1>
        <p>
          {t('httpErrors:unauthorized.subtitle')}
          <br />
          {t('httpErrors:unauthorized.text')}
        </p>
        <p>{t('httpErrors:unauthorized.userInfo', { email: props.email })}</p>
        {props.onRefresh && (
          <Button
            className={classes.actionButton}
            variant="contained"
            color="primary"
            onClick={() => {
              props.onRefresh && props.onRefresh();
            }}
          >
            {t('httpErrors:unauthorized.actions.refresh')}
          </Button>
        )}
        {props.onReportError && (
          <Button
            color="primary"
            className={classes.actionButton}
            onClick={() => {
              props.onReportError && props.onReportError();
            }}
          >
            {t('httpErrors:unauthorized.actions.report')}
          </Button>
        )}
        {props.onLogout && (
          <Button
            color="primary"
            className={classes.actionButton}
            onClick={() => {
              props.onLogout && props.onLogout();
            }}
          >
            {t('httpErrors:unauthorized.actions.logout')}
          </Button>
        )}
      </div>
    </div>
  );
};
